import { useState } from "react";

import { TwModal } from '@ui-component-library';

const NHInfo = (props) => {
    const [visible, setVisible] = useState(false)
    return <>
    <img className="pl-1" src={`${Window.static_path}img/icons/info-circle.svg`} style={{height:"16px", cursor:"pointer"}} onClick={() => {setVisible(true);}} />
        <TwModal isOpen={visible}>
        <TwModal.Header>
            <div className="flex justify-between items-center">
                <span className="font-medium">{props.title}</span>
                <button type="button" className="ml-4 text-2xl leading-none" onClick={() => setVisible(false)} aria-label="Close">&times;</button>
            </div>
        </TwModal.Header>
        <TwModal.Content>{props.body}</TwModal.Content>
        <TwModal.Footer><div /></TwModal.Footer>
      </TwModal>
    </>
}

export default NHInfo;